// RB TIM — content data (Serbian Latin)
// RB TIM image paths and content data

export const SITE = {
  name: "RB TIM",
  description:
    "Standardni kontejneri za praktičnu upotrebu, brzu izradu i različite namene.",
  phone: "+381 69 120 5502",
  phoneHref: "tel:+381691205502",
  phoneDisplay: "+381 69 120 5502",
  email: "rbtim034@gmail.com",
  emailHref: "mailto:rbtim034@gmail.com",
  street: "Banijskih Brigada 19",
  city: "Kragujevac",
  country: "Srbija",
  address: "Banijskih Brigada 19, Kragujevac",
  fullAddress: "Banijskih Brigada 19, 34000 Kragujevac, Srbija",
  hours: [
    { day: "Pon – Pet", value: "08:00 – 17:00" },
    { day: "Subota", value: "09:00 – 14:00" },
    { day: "Nedelja", value: "Ne radimo" },
  ],
  // For JSON-LD openingHoursSpecification
  hoursStructured: [
    { days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], opens: "08:00", closes: "17:00" },
    { days: ["Saturday"], opens: "09:00", closes: "14:00" },
  ],
};

// Local RB TIM images — files live in /public/images
const img = (file) => `/images/${file}`;

const IMG = {
  hero: img("rbtim-hero-za-prvu-stranu.webp"),

  standardni1: img("rbtim-standardni-gradjevinski.webp"),
  standardni2: img("rbtim-standardni-gradjevinski.webp"),
  standardni3: img("rbtim-standardni-gradjevinski.webp"),

  stambeni1: img("rbtim-stambeni.webp"),
  stambeni2: img("rbtim-stambeni.webp"),
  stambeni3: img("rbtim-stambeni.webp"),

  kancelarijski1: img("rbtim-kancelariski.webp"),
  kancelarijski2: img("rbtim-kancelariski.webp"),
  kancelarijski3: img("rbtim-kancelariski.webp"),

  sanitarni1: img("rbtim-sanitarni-1.webp"),
  sanitarni2: img("rbtim-sanitarni-2.webp"),
  sanitarni3: img("rbtim-sanitarni-1.webp"),

  gradjevinski1: img("rbtim-standardni-gradjevinski.webp"),
  gradjevinski2: img("rbtim-standardni-gradjevinski.webp"),
  gradjevinski3: img("rbtim-standardni-gradjevinski.webp"),

  portirnice1: img("rbtim-portirnica-1.webp"),
  portirnice2: img("rbtim-portirnice-2.webp"),
  portirnice3: img("rbtim-portirnica-3.webp"),

  pomocni1: img("rbtim-vikendice.webp"),
  pomocni2: img("rbtim-vikendice.webp"),
  pomocni3: img("rbtim-vikendice.webp"),

  industrial: img("rbtim-standardni-gradjevinski.webp"),
};

export const IMAGES = IMG;

// Model categories — used across nav, home grid, model detail pages
export const MODELS = [
  {
    key: "standardni",
    slug: "standardni-kontejneri",
    title: "Standardni kontejneri",
    short:
      "Osnovni model kontejnera namenjen za različite vrste upotrebe. Praktičan, jednostavan i brzo dostupan.",
    long:
      "Standardni kontejneri su praktično rešenje za različite namene — od pomoćnog prostora i magacina, do kancelarije, gradilišta ili privremenog objekta.",
    image: IMG.standardni1,
    images: [
      IMG.standardni1,
      IMG.standardni2,
      IMG.standardni3,
      IMG.gradjevinski1,
      IMG.kancelarijski1,
      IMG.hero,
    ],
    benefits: [
      "Brza izrada i dostupnost",
      "Proverena konstrukcija",
      "Lako transportovanje",
      "Prilagodljiv osnovnim potrebama",
      "Povoljna opcija za teren",
      "Standardne dimenzije",
    ],
    useCases: [
      "Magacin",
      "Gradilište",
      "Pomoćni prostor",
      "Privremena kancelarija",
      "Plac ili dvorište",
      "Industrijski objekti",
    ],
  },
  {
    key: "stambeni",
    slug: "stambeni-kontejneri",
    title: "Stambeni kontejneri",
    short:
      "Rešenje za privremeni ili dodatni stambeni prostor, vikend objekte i smeštajne jedinice.",
    long:
      "Stambeni kontejneri se koriste kao dodatni prostor, vikend objekti, privremeni smeštaj ili funkcionalne smeštajne jedinice.",
    image: IMG.stambeni1,
    images: [
      IMG.stambeni1,
      IMG.stambeni2,
      IMG.stambeni3,
      IMG.portirnice1,
      IMG.portirnice3,
      IMG.standardni2,
    ],
    benefits: [
      "Funkcionalan stambeni prostor",
      "Brza izrada",
      "Mogućnost prilagođavanja rasporeda",
      "Pogodno za vikend placeve",
      "Praktično rešenje za smeštaj",
      "Jednostavno postavljanje",
    ],
    useCases: [
      "Vikend objekti",
      "Privremeni smeštaj",
      "Dodatni stambeni prostor",
      "Smeštaj radnika",
      "Plac u prirodi",
      "Sezonsko stanovanje",
    ],
  },
  {
    key: "kancelarijski",
    slug: "kancelarijski-kontejneri",
    title: "Kancelarijski kontejneri",
    short:
      "Funkcionalan prostor za rad, administraciju, gradilišta, firme i privremene kancelarije.",
    long:
      "Kancelarijski kontejneri omogućavaju brz i funkcionalan radni prostor za firme, gradilišta, administraciju i privremene poslovne potrebe.",
    image: IMG.kancelarijski1,
    images: [
      IMG.kancelarijski1,
      IMG.kancelarijski2,
      IMG.kancelarijski3,
      IMG.standardni1,
      IMG.gradjevinski2,
      IMG.standardni3,
    ],
    benefits: [
      "Funkcionalan radni prostor",
      "Brza isporuka",
      "Više kontejnera se može spojiti",
      "Pogodno za gradilišta",
      "Jednostavno održavanje",
      "Praktičan za teren",
    ],
    useCases: [
      "Gradilišne kancelarije",
      "Administrativni prostor",
      "Firme i poslovne potrebe",
      "Sale za sastanke",
      "Inženjerski timovi",
      "Privremena sedišta",
    ],
  },
  {
    key: "sanitarni",
    slug: "sanitarni-kontejneri",
    title: "Sanitarni kontejneri",
    short:
      "Kontejneri prilagođeni za sanitarne potrebe, toalete, tuševe i objekte na terenu.",
    long:
      "Sanitarni kontejneri su namenjeni za toalete, tuševe i sanitarne potrebe na gradilištima, placevima, kampovima i poslovnim lokacijama.",
    image: IMG.sanitarni1,
    images: [
      IMG.sanitarni1,
      IMG.sanitarni2,
      IMG.sanitarni3,
      IMG.standardni2,
      IMG.portirnice2,
      IMG.kancelarijski2,
    ],
    benefits: [
      "Toaletni i tuš prostor",
      "Brza montaža",
      "Praktično za teren",
      "Različite konfiguracije",
      "Lako čišćenje",
      "Funkcionalno rešenje",
    ],
    useCases: [
      "Gradilišta",
      "Kampovi i terenski radovi",
      "Plac sa radnicima",
      "Sezonski objekti",
      "Sportski tereni",
      "Privremene lokacije",
    ],
  },
  {
    key: "gradjevinski",
    slug: "gradjevinski-kontejneri",
    title: "Građevinski kontejneri",
    short:
      "Praktični kontejneri za gradilišta, radnike, opremu, alat i organizaciju posla na terenu.",
    long:
      "Građevinski kontejneri su praktično rešenje za organizaciju rada na terenu, smeštaj radnika, alat, opremu i privremene kancelarije.",
    image: IMG.gradjevinski1,
    images: [
      IMG.gradjevinski1,
      IMG.gradjevinski2,
      IMG.gradjevinski3,
      IMG.kancelarijski2,
      IMG.standardni3,
      IMG.hero,
    ],
    benefits: [
      "Otporna konstrukcija",
      "Sigurno čuvanje alata i opreme",
      "Funkcionalan prostor na terenu",
      "Brza isporuka na gradilište",
      "Lako preseljavanje",
      "Pogodno za radne timove",
    ],
    useCases: [
      "Gradilišta",
      "Magacin alata",
      "Smeštaj radnika",
      "Privremena kancelarija na terenu",
      "Skladištenje opreme",
      "Organizacija posla",
    ],
  },
  {
    key: "portirnice",
    slug: "portirnice",
    title: "Portirnice",
    short:
      "Manji objekti namenjeni za kontrolu ulaza, čuvare, naplatne punktove i poslovne komplekse.",
    long:
      "Portirnice su namenjene za kontrolu ulaza, čuvarske pozicije, naplatne punktove, firme, parkinge i poslovne komplekse.",
    image: IMG.portirnice1,
    images: [
      IMG.portirnice1,
      IMG.portirnice2,
      IMG.portirnice3,
      IMG.standardni1,
      IMG.kancelarijski3,
      IMG.stambeni1,
    ],
    benefits: [
      "Kompaktan i praktičan model",
      "Pogodno za kontrolu ulaza",
      "Brza postavka",
      "Različite veličine",
      "Pogodno za parkinge i firme",
      "Funkcionalan radni prostor",
    ],
    useCases: [
      "Poslovni kompleksi",
      "Parkinzi",
      "Industrijska dvorišta",
      "Naplatni punktovi",
      "Ulazne kapije",
      "Stambeni kompleksi",
    ],
  },
  {
    key: "pomocni",
    slug: "pomocni-objekti",
    title: "Vikendice",
    short:
      "Kontejnerske vikendice za plac, odmor i praktičan boravak bez klasične gradnje.",
    long:
      "Kontejnerske vikendice su praktično rešenje za plac, odmor i dodatni boravišni prostor. Raspored, kupatilo, terasa, prozori i završna obrada definišu se prema načinu korišćenja.",
    image: IMG.pomocni1,
    images: [
      IMG.pomocni1,
      IMG.stambeni1,
      IMG.standardni1,
      IMG.kancelarijski1,
      IMG.portirnice1,
      IMG.hero,
    ],
    benefits: [
      "Brže rešenje od klasične gradnje",
      "Pogodno za vikend placeve",
      "Mogućnost kupatila i dodatnih pregrada",
      "Raspored se prilagođava nameni",
      "Jednostavno postavljanje na pripremljenu lokaciju",
      "Dobar odnos funkcionalnosti i ulaganja",
    ],
    useCases: [
      "Vikend plac",
      "Odmor u prirodi",
      "Mali stambeni objekat",
      "Smeštaj za goste",
      "Plac pored reke ili jezera",
      "Sezonski boravak",
    ],
  },
];


export const TECHNICAL_INFO = {
  standardni: {
    eyebrow: "Tehnički pregled",
    title: "Standardni kontejner — osnova koja se prilagođava nameni",
    intro:
      "Osnovni RB TIM model je napravljen kao funkcionalan prostor koji može da radi kao magacin, kancelarija, pomoćni objekat ili terenski prostor. Raspored vrata, prozora i sanitarnog bloka se definiše pre izrade.",
    imageTitle: "Standardni rasporedi",
    keySpecs: [
      { label: "Standard", value: "6,00 × 2,40 × 2,70 m" },
      { label: "Kompaktne opcije", value: "3,00 m i 4,00 m dužine" },
      { label: "Stolarija", value: "PVC vrata i prozor" },
      { label: "Instalacije", value: "Elektro priprema u osnovi" },
    ],
    included: [
      "Čelična konstrukcija sa termoizolacionim panelima",
      "Podna podkonstrukcija, OSB / ploča i završna podna obloga po dogovoru",
      "Elektro instalacija sa rasvetom, utičnicama, osiguračima i spoljnim priključkom",
      "Mogućnost dodavanja WC-a, kupatila, dodatnih prozora i pregradnih zidova",
    ],
    layouts: [
      {
        key: "standard-open",
        label: "Običan",
        name: "Otvoren standardni kontejner",
        dimensions: "6,00 × 2,40 × 2,70 m",
        area: "14,4 m²",
        purpose: "Magacin, kancelarija, pomoćni prostor",
        description:
          "Najčistija varijanta bez pregrada. Dobija se maksimalan otvoren prostor za robu, alat, sto, police ili radnu zonu.",
        plan: { type: "open", modules: 1, ratio: "wide", hasWindow: true, hasDoor: true },
      },
      {
        key: "standard-wc",
        label: "WC",
        name: "Standardni kontejner sa WC-om",
        dimensions: "6,00 × 2,40 × 2,70 m",
        area: "14,4 m²",
        purpose: "Radni prostor + sanitarni čvor",
        description:
          "Praktična opcija kada objekat mora da ima zaseban toalet, ali glavni prostor i dalje ostaje upotrebljiv.",
        plan: { type: "wc", modules: 1, ratio: "wide", hasWindow: true, hasDoor: true },
      },
      {
        key: "standard-bath",
        label: "Kupatilo",
        name: "Standardni kontejner sa kupatilom",
        dimensions: "6,00 × 2,40 × 2,70 m",
        area: "14,4 m²",
        purpose: "Smeštaj, plac, radnici, vikend upotreba",
        description:
          "Varijanta sa kupatilom i tušem za objekte koji se koriste duže ili zahtevaju kompletnu sanitarnu funkciju.",
        plan: { type: "bath", modules: 1, ratio: "wide", hasWindow: true, hasDoor: true },
      },
    ],
  },

  stambeni: {
    eyebrow: "Stambena konfiguracija",
    title: "Stambeni kontejner — prostor za boravak i smeštaj",
    intro:
      "Stambeni kontejner se planira kao upotrebljiv prostor za odmor, radnike, vikend plac ili privremeni boravak. Najbitnije je da raspored ne bude slučajan: ulaz, prozor, mokri čvor i slobodna zona moraju da rade zajedno.",
    imageTitle: "Stambeni rasporedi",
    keySpecs: [
      { label: "Osnovna mera", value: "6,00 × 2,40 × 2,70 m" },
      { label: "Veći format", value: "6,00 × 4,80 m ili 9,00 × 2,40 m" },
      { label: "Opcije", value: "WC ili kompletno kupatilo" },
      { label: "Namena", value: "Vikend objekat, smeštaj, dodatni prostor" },
    ],
    included: [
      "Izolovani zidovi i krovni paneli za svakodnevnu upotrebu",
      "PVC stolarija i raspored otvora prema nameni prostora",
      "Elektro instalacija za osvetljenje, utičnice i osnovne uređaje",
      "Mogućnost kupatila, čajne kuhinje, dodatnih modula i terasa po projektu",
    ],
    layouts: [
      {
        key: "living-open",
        label: "Običan",
        name: "Stambeni otvoreni prostor",
        dimensions: "6,00 × 2,40 × 2,70 m",
        area: "14,4 m²",
        purpose: "Soba, vikend plac, dodatni prostor",
        description:
          "Otvoren stambeni raspored za osnovni boravak. Najbolji kada kupac želi čist prostor koji kasnije oprema po meri.",
        plan: { type: "living", modules: 1, ratio: "wide", hasWindow: true, hasDoor: true },
      },
      {
        key: "living-wc",
        label: "WC",
        name: "Stambeni kontejner sa WC-om",
        dimensions: "6,00 × 2,40 × 2,70 m",
        area: "14,4 m²",
        purpose: "Boravak + osnovni sanitarni čvor",
        description:
          "Dobar balans kada je potreban sanitarni čvor, ali nije neophodan tuš. Glavni deo ostaje za krevet, sto ili opremu.",
        plan: { type: "wc", modules: 1, ratio: "wide", hasWindow: true, hasDoor: true },
      },
      {
        key: "living-bath",
        label: "Kupatilo",
        name: "Stambeni kontejner sa kupatilom",
        dimensions: "6,00 × 2,40 × 2,70 m",
        area: "14,4 m²",
        purpose: "Vikend objekat i smeštaj za duži boravak",
        description:
          "Kompletnija varijanta sa tušem, bojlerom i sanitarnim prostorom. Ovo je realnija opcija za boravak koji traje više od par sati.",
        plan: { type: "bath", modules: 1, ratio: "wide", hasWindow: true, hasDoor: true },
      },
    ],
  },

  kancelarijski: {
    eyebrow: "Radni prostor",
    title: "Kancelarijski kontejner — brzo postavljena kancelarija na terenu",
    intro:
      "Kancelarijski kontejner mora da bude jednostavan za korišćenje: dovoljno svetla, logičan ulaz, elektro instalacija i mogućnost da se koristi odmah po postavljanju. Idealan je za gradilišta, firme, administraciju i privremene kancelarije.",
    imageTitle: "Kancelarijski rasporedi",
    keySpecs: [
      { label: "Osnovna mera", value: "6,00 × 2,40 × 2,70 m" },
      { label: "Duple kancelarije", value: "6,00 × 4,80 × 2,70 m" },
      { label: "Oprema", value: "Vrata, prozori, rasveta, utičnice" },
      { label: "Opcije", value: "WC, pregrade, više modula" },
    ],
    included: [
      "Otvoren kancelarijski prostor ili prostor podeljen pregradama",
      "PVC prozori za prirodno svetlo i ventilaciju",
      "Elektro instalacija spremna za radne stolove, rasvetu i opremu",
      "Mogućnost povezivanja više kontejnera u veći kancelarijski objekat",
    ],
    layouts: [
      {
        key: "office-open",
        label: "Običan",
        name: "Jedna kancelarija",
        dimensions: "6,00 × 2,40 × 2,70 m",
        area: "14,4 m²",
        purpose: "Administracija, šef gradilišta, privremena kancelarija",
        description:
          "Najbrža varijanta: jedan čist radni prostor sa vratima, prozorom, rasvetom i utičnicama.",
        plan: { type: "office", modules: 1, ratio: "wide", hasWindow: true, hasDoor: true },
      },
      {
        key: "office-wc",
        label: "WC",
        name: "Kancelarija sa WC-om",
        dimensions: "6,00 × 2,40 × 2,70 m",
        area: "14,4 m²",
        purpose: "Samostalna kancelarija na lokaciji",
        description:
          "Varijanta za lokacije gde nema postojećeg toaleta. Glavni prostor ostaje za stolove, arhivu i opremu.",
        plan: { type: "wc", modules: 1, ratio: "wide", hasWindow: true, hasDoor: true },
      },
      {
        key: "office-double",
        label: "Dupli",
        name: "Dupla kancelarija / spojeni moduli",
        dimensions: "6,00 × 4,80 × 2,70 m",
        area: "28,8 m²",
        purpose: "Veći tim, sala za sastanke, kancelarijski blok",
        description:
          "Dva spojena modula daju mnogo ozbiljniji radni prostor. Ovo je opcija za timove kojima jedan standardni modul nije dovoljan.",
        plan: { type: "doubleOffice", modules: 2, ratio: "double", hasWindow: true, hasDoor: true },
      },
    ],
  },

  sanitarni: {
    eyebrow: "Sanitarni modul",
    title: "Sanitarni kontejner — WC, tuševi i mokri čvorovi za teren",
    intro:
      "Sanitarni kontejner ne sme da bude tretiran kao obična kutija sa opremom. Bitni su raspored kabina, odvod, dovod vode, bojler, ventilacija i lako održavanje.",
    imageTitle: "Sanitarni rasporedi",
    keySpecs: [
      { label: "Kompaktni WC", value: "1,20 × 1,20 × 2,70 m" },
      { label: "Standardni sanitarni", value: "6,00 × 2,40 × 2,70 m" },
      { label: "Oprema", value: "WC, lavabo, tuš, bojler po varijanti" },
      { label: "Instalacije", value: "Vodovod, kanalizacija i elektro" },
    ],
    included: [
      "Razvod vode i kanalizacije prema izabranom rasporedu",
      "Sanitarna oprema: WC šolja, lavabo, tuš i bojler prema varijanti",
      "Odvojene kabine ili zajednički sanitarni prostor po nameni",
      "Pogodno za gradilišta, kampove, proizvodne pogone i sportske lokacije",
    ],
    layouts: [
      {
        key: "sanitary-wc-small",
        label: "WC",
        name: "Kompaktni WC modul",
        dimensions: "1,20 × 1,20 × 2,70 m",
        area: "1,44 m²",
        purpose: "Jedan toalet za manje lokacije",
        description:
          "Mali sanitarni modul kada je cilj najkraće moguće rešenje za osnovni WC na lokaciji.",
        plan: { type: "smallWc", modules: 1, ratio: "compact", hasWindow: true, hasDoor: true },
      },
      {
        key: "sanitary-shower",
        label: "Tuševi",
        name: "Sanitarni kontejner sa tuševima",
        dimensions: "6,00 × 2,40 × 2,70 m",
        area: "14,4 m²",
        purpose: "Tuševi, radnici, kampovi, tereni",
        description:
          "Raspored za lokacije gde je pranje i presvlačenje važnije od klasičnog kancelarijskog prostora.",
        plan: { type: "showers", modules: 1, ratio: "wide", hasWindow: true, hasDoor: true },
      },
      {
        key: "sanitary-cabins",
        label: "Više kabina",
        name: "Sanitarni kontejner sa više kabina",
        dimensions: "6,00 × 2,40 × 2,70 m",
        area: "14,4 m²",
        purpose: "Gradilišta i lokacije sa većim brojem korisnika",
        description:
          "Varijanta sa više WC / tuš kabina za veći protok ljudi. Raspored kabina se definiše prema realnoj potrebi lokacije.",
        plan: { type: "multiSanitary", modules: 1, ratio: "wide", hasWindow: true, hasDoor: true },
      },
    ],
  },

  gradjevinski: {
    eyebrow: "Terenska upotreba",
    title: "Građevinski kontejner — alat, oprema, radnici i organizacija gradilišta",
    intro:
      "Građevinski kontejner mora da izdrži svakodnevnu terensku upotrebu. Koristi se za alat, opremu, smeštaj radnika, kancelariju šefa gradilišta ili kombinaciju više namena.",
    imageTitle: "Građevinski rasporedi",
    keySpecs: [
      { label: "Kompaktni", value: "3,00 × 2,40 × 2,70 m" },
      { label: "Standardni", value: "6,00 × 2,40 × 2,70 m" },
      { label: "Produženi", value: "9,00 × 2,40 × 2,70 m" },
      { label: "Namena", value: "Alat, radnici, kancelarija, magacin" },
    ],
    included: [
      "Robusna konstrukcija pogodna za čestu selidbu po terenima",
      "Otvoren prostor za alat ili opremu, ili raspored sa radnim/smeštajnim delom",
      "Elektro instalacija i osvetljenje za upotrebu na gradilištu",
      "Mogućnost WC-a, kupatila, dodatnih vrata i sigurnosnih elemenata po dogovoru",
    ],
    layouts: [
      {
        key: "site-storage",
        label: "Magacin",
        name: "Građevinski magacin",
        dimensions: "6,00 × 2,40 × 2,70 m",
        area: "14,4 m²",
        purpose: "Alat, materijal i oprema",
        description:
          "Otvoren prostor za odlaganje i zaštitu opreme. Najpraktičnija varijanta za gradilišta gde je sigurnost alata prioritet.",
        plan: { type: "storage", modules: 1, ratio: "wide", hasWindow: false, hasDoor: true },
      },
      {
        key: "site-office",
        label: "Kancelarija",
        name: "Gradilišna kancelarija",
        dimensions: "6,00 × 2,40 × 2,70 m",
        area: "14,4 m²",
        purpose: "Organizacija gradilišta i dokumentacija",
        description:
          "Kontejner za nadzor, dokumentaciju i timske dogovore. Bolji izbor od improvizovanog prostora na gradilištu.",
        plan: { type: "office", modules: 1, ratio: "wide", hasWindow: true, hasDoor: true },
      },
      {
        key: "site-living",
        label: "Smeštaj",
        name: "Smeštajni građevinski kontejner",
        dimensions: "9,00 × 2,40 × 2,70 m",
        area: "21,6 m²",
        purpose: "Radnici i duži boravak na terenu",
        description:
          "Produženi format daje više mesta za krevete, garderobu i opremu. Ima smisla kada je tim duže na lokaciji.",
        plan: { type: "living", modules: 1, ratio: "extraWide", hasWindow: true, hasDoor: true },
      },
    ],
  },

  portirnice: {
    eyebrow: "Kontrola ulaza",
    title: "Portirnice — kompaktan objekat za čuvara, kapiju i naplatni punkt",
    intro:
      "Portirnica mora da bude mala, pregledna i funkcionalna. Najčešće se traži za ulaze u firme, parkinge, stambene komplekse, industrijska dvorišta i naplatne punktove.",
    imageTitle: "Rasporedi portirnica",
    keySpecs: [
      { label: "Kompaktna", value: "1,20 × 1,20 × 2,70 m" },
      { label: "Veća portirnica", value: "3,00 × 2,40 × 2,70 m" },
      { label: "Oprema", value: "Vrata, prozor, šalter po potrebi" },
      { label: "Opcije", value: "WC, dodatni prozor, klizni šalter" },
    ],
    included: [
      "Kompaktan prostor za jednu osobu ili veći model za duže smene",
      "Prozor / šalter prema strani sa koje se kontroliše ulaz",
      "Elektro instalacija za svetlo, grejanje/hlađenje i osnovnu opremu",
      "Mogućnost WC-a za lokacije gde portirnica funkcioniše samostalno",
    ],
    layouts: [
      {
        key: "gate-basic",
        label: "Osnovna",
        name: "Osnovna portirnica",
        dimensions: "1,20 × 1,20 × 2,70 m",
        area: "1,44 m²",
        purpose: "Čuvarsko mesto i kontrola ulaza",
        description:
          "Minimalna portirnica za jednu osobu. Nije luksuz, nego funkcionalno rešenje kada prostor mora biti kompaktan.",
        plan: { type: "guard", modules: 1, ratio: "compact", hasWindow: true, hasDoor: true },
      },
      {
        key: "gate-counter",
        label: "Šalter",
        name: "Portirnica sa šalterom",
        dimensions: "1,20 × 1,20 × 2,70 m",
        area: "1,44 m²",
        purpose: "Naplata, evidencija, komunikacija sa strankama",
        description:
          "Varijanta sa kliznim šalterom / prozorom za ulazne kapije, parkinge i naplatne punktove.",
        plan: { type: "counter", modules: 1, ratio: "compact", hasWindow: true, hasDoor: true },
      },
      {
        key: "gate-wc",
        label: "WC",
        name: "Veća portirnica sa WC-om",
        dimensions: "3,00 × 2,40 × 2,70 m",
        area: "7,2 m²",
        purpose: "Duge smene i lokacije bez dodatnog toaleta",
        description:
          "Veći format za ozbiljnije lokacije. Dodaje se WC, a radni deo ostaje dovoljno pregledan za portira.",
        plan: { type: "wc", modules: 1, ratio: "medium", hasWindow: true, hasDoor: true },
      },
    ],
  },

  pomocni: {
    eyebrow: "Vikend objekat",
    title: "Vikendica od kontejnera — funkcionalan prostor za plac i odmor",
    intro:
      "Vikendica od kontejnera mora da ima pametan raspored, a ne samo lep izgled. Najčešće se planira prostor za boravak, spavanje, kupatilo i eventualno terasa ili dodatni modul. Finalne mere, pozicije vrata, prozora i instalacija se potvrđuju pre izrade.",
    imageTitle: "Rasporedi za vikendice",
    keySpecs: [
      { label: "Osnovna mera", value: "6,00 × 2,40 × 2,70 m" },
      { label: "Veća vikendica", value: "6,00 × 4,80 × 2,70 m" },
      { label: "Opcije", value: "Kupatilo, WC, terasa, pregrade" },
      { label: "Namena", value: "Plac, odmor, smeštaj, sezonski boravak" },
    ],
    included: [
      "Izolovan prostor prilagođen boravku na placu ili vikend lokaciji",
      "Raspored vrata, prozora, kupatila i pregrada prema konkretnom zahtevu",
      "Elektro instalacija, rasveta, utičnice i priprema za dodatnu opremu po dogovoru",
      "Mogućnost spajanja dva modula za veći boravak, spavaću zonu ili odvojeno kupatilo",
    ],
    layouts: [
      {
        key: "weekend-open",
        label: "Obična",
        name: "Vikendica — otvoren prostor",
        dimensions: "6,00 × 2,40 × 2,70 m",
        area: "14,4 m²",
        purpose: "Plac, odmor, osnovni boravak",
        description:
          "Otvoren raspored za ljude koji žele čist prostor za boravak, sto, ležaj i opremanje po meri. Najbolji izbor kada se kupatilo rešava odvojeno ili naknadno.",
        plan: { type: "living", modules: 1, ratio: "wide", hasWindow: true, hasDoor: true },
      },
      {
        key: "weekend-wc",
        label: "WC",
        name: "Vikendica sa WC-om",
        dimensions: "6,00 × 2,40 × 2,70 m",
        area: "14,4 m²",
        purpose: "Plac sa osnovnim sanitarnim čvorom",
        description:
          "Dobar kompromis kada objekat treba da bude samostalniji, ali nije potreban kompletan tuš prostor. Ostatak modula ostaje za boravak i spavanje.",
        plan: { type: "wc", modules: 1, ratio: "wide", hasWindow: true, hasDoor: true },
      },
      {
        key: "weekend-bath",
        label: "Kupatilo",
        name: "Vikendica sa kupatilom",
        dimensions: "6,00 × 2,40 × 2,70 m",
        area: "14,4 m²",
        purpose: "Duži boravak, sezonska vikendica, smeštaj",
        description:
          "Najrealnija opcija za vikend upotrebu. Kupatilo sa tušem omogućava duži boravak, a preostali deo se koristi kao soba / dnevni prostor.",
        plan: { type: "bath", modules: 1, ratio: "wide", hasWindow: true, hasDoor: true },
      },
    ],
  },
};

export const DIMENSION_CATALOG = [
  {
    title: "Osnovni i radni moduli",
    items: [
      {
        name: "Standardni kontejner",
        dimensions: "6,00 × 2,40 × 2,70 m",
        area: "14,4 m²",
        purpose: "magacin, kancelarija, pomoćni prostor, teren",
        note: "Najčešća osnova; unutrašnja mera oko 5,82 × 2,22 × 2,40 m.",
      },
      {
        name: "Kompaktni kontejner",
        dimensions: "3,00 × 2,40 × 2,70 m",
        area: "7,2 m²",
        purpose: "portirnica, alat, mali magacin, gradilište",
        note: "Kada je lokacija ograničena ili nije potreban pun format.",
      },
      {
        name: "Srednji kontejner",
        dimensions: "4,00 × 2,40 × 2,70 m",
        area: "9,6 m²",
        purpose: "pomoćni objekat, kancelarija, prodajni punkt",
        note: "Bolji balans prostora i transporta od male portirnice.",
      },
      {
        name: "Produženi kontejner",
        dimensions: "9,00 × 2,40 × 2,70 m",
        area: "21,6 m²",
        purpose: "smeštaj, veći magacin, gradilišni objekat",
        note: "Daje više korisne dužine bez spajanja više modula.",
      },
    ],
  },
  {
    title: "Spojeni i specijalni formati",
    items: [
      {
        name: "Dupli / spojeni modul",
        dimensions: "6,00 × 4,80 × 2,70 m",
        area: "28,8 m²",
        purpose: "stambeni prostor, veća kancelarija, poslovni objekat",
        note: "Dva spojena modula za ozbiljniji raspored i veću širinu.",
      },
      {
        name: "Mala portirnica / WC modul",
        dimensions: "1,20 × 1,20 × 2,70 m",
        area: "1,44 m²",
        purpose: "čuvarsko mesto, naplatni punkt, kompaktni WC",
        note: "Minimalna osnova kada prostor mora biti maksimalno kompaktan.",
      },
      {
        name: "Sanitarni standardni modul",
        dimensions: "6,00 × 2,40 × 2,70 m",
        area: "14,4 m²",
        purpose: "WC kabine, tuševi, sanitarni blok za teren",
        note: "Raspored kabina, bojlera, dovoda i odvoda se definiše po upitu.",
      },
    ],
  },
];

export const CONFIGURATOR_LIBRARY = [
  {
    key: "standardni-600",
    modelKey: "standardni",
    name: "Standardni 6,00 m",
    dimensions: "6,00 × 2,40 × 2,70 m",
    ratio: "wide",
    previewType: "open",
    description: "Najčešća osnova za magacin, kancelariju, pomoćni objekat ili terensku upotrebu.",
  },
  {
    key: "stambeni-600",
    modelKey: "stambeni",
    name: "Stambeni 6,00 m",
    dimensions: "6,00 × 2,40 × 2,70 m",
    ratio: "wide",
    previewType: "living",
    description: "Osnovni stambeni modul za vikend plac, smeštaj ili dodatni prostor.",
  },
  {
    key: "kancelarijski-600",
    modelKey: "kancelarijski",
    name: "Kancelarijski 6,00 m",
    dimensions: "6,00 × 2,40 × 2,70 m",
    ratio: "wide",
    previewType: "office",
    description: "Brzo postavljena kancelarija za firme, gradilišta i administraciju.",
  },
  {
    key: "dupli-648",
    modelKey: "kancelarijski",
    name: "Dupli modul 6,00 × 4,80 m",
    dimensions: "6,00 × 4,80 × 2,70 m",
    ratio: "double",
    previewType: "doubleOffice",
    description: "Veća osnova kada jedan standardni modul nije dovoljan.",
  },
  {
    key: "dupli-1224",
    modelKey: "kancelarijski",
    name: "Dupli po dužini 12,00 × 2,40 m",
    dimensions: "12,00 × 2,40 × 2,70 m",
    ratio: "long",
    previewType: "doubleOffice",
    description: "Dva modula spojena po dužini za veći kancelarijski, stambeni ili radni prostor.",
  },
  {
    key: "gradjevinski-300",
    modelKey: "gradjevinski",
    name: "Građevinski 3,00 m",
    dimensions: "3,00 × 2,40 × 2,70 m",
    ratio: "medium",
    previewType: "storage",
    description: "Kompaktan objekat za alat, materijal ili manju terensku kancelariju.",
  },
  {
    key: "gradjevinski-900",
    modelKey: "gradjevinski",
    name: "Produženi 9,00 m",
    dimensions: "9,00 × 2,40 × 2,70 m",
    ratio: "extraWide",
    previewType: "storage",
    description: "Više korisne dužine za opremu, smeštaj radnika ili veći magacin.",
  },
  {
    key: "portirnica-120",
    modelKey: "portirnice",
    name: "Portirnica 1,20 m",
    dimensions: "1,20 × 1,20 × 2,70 m",
    ratio: "compact",
    previewType: "guard",
    description: "Minimalna čuvarska kućica za kapiju, parking ili naplatni punkt.",
  },
  {
    key: "pomocni-400",
    modelKey: "pomocni",
    name: "Pomoćni 4,00 m",
    dimensions: "4,00 × 2,40 × 2,70 m",
    ratio: "medium",
    previewType: "storage",
    description: "Pomoćni prostor za dvorište, plac, alat, radionicu ili mali magacin.",
  },
  {
    key: "sanitarni-600",
    modelKey: "sanitarni",
    name: "Sanitarni 6,00 m",
    dimensions: "6,00 × 2,40 × 2,70 m",
    ratio: "wide",
    previewType: "multiSanitary",
    description: "Osnova za WC kabine, tuševe, bojler i sanitarne instalacije.",
  },
];

export const CONFIGURATOR_OPTIONS = [
  { key: "door", group: "Otvori", label: "PVC vrata", note: "Pozicija i smer otvaranja po dogovoru." },
  { key: "extra-door", group: "Otvori", label: "Dodatna vrata", note: "Za modele sa više prostorija ili izlaza." },
  { key: "window", group: "Otvori", label: "PVC prozor", note: "Standardna opcija za svetlo i ventilaciju." },
  { key: "extra-window", group: "Otvori", label: "Dodatni prozor", note: "Korisno za kancelarije, portirnice i stambene module." },
  { key: "partition", group: "Raspored", label: "Pregradni zid", note: "Za odvajanje kancelarije, WC-a, skladišta ili sobe." },
  { key: "wc", group: "Sanitarije", label: "WC", note: "WC prostor sa potrebnim dovodom i odvodom." },
  { key: "bathroom", group: "Sanitarije", label: "Kupatilo", note: "Kompletnija varijanta sa tušem i sanitarnom opremom." },
  { key: "electro", group: "Instalacije", label: "Elektro instalacije", note: "Rasveta, utičnice, osigurači i spoljni priključak." },
  { key: "water", group: "Instalacije", label: "Vodovod i kanalizacija", note: "Za WC, kupatilo i sanitarne module." },
  { key: "ac-prep", group: "Dodatna oprema", label: "Priprema za klimu", note: "Pozicija uređaja se planira pre izrade." },
  { key: "color", group: "Dodatna oprema", label: "Boja / završna obrada", note: "RAL tonovi i dekor po dogovoru." },
];


export const BENEFITS = [
  {
    title: "Brza izrada",
    text: "Kontejneri se izrađuju u kratkom roku, što omogućava brz početak korišćenja.",
  },
  {
    title: "Standardni provereni modeli",
    text: "Radimo sa standardnim modelima kontejnera koji su provereni u praksi.",
  },
  {
    title: "Praktična rešenja za teren",
    text: "Kontejneri su pogodni za rad na terenu, gradilišta i privremene objekte.",
  },
  {
    title: "Povoljnija opcija za osnovne potrebe",
    text: "Praktična cena za funkcionalan i upotrebljiv prostor u kratkom roku.",
  },
  {
    title: "Mogućnost prilagođavanja nameni",
    text: "Osnovne karakteristike i raspored se mogu prilagoditi vašim potrebama.",
  },
  {
    title: "Dogovor prema projektu",
    text: "Svaka porudžbina se dogovara prema konkretnoj nameni i zahtevima.",
  },
];

export const USE_CASES = [
  "Gradilišta",
  "Firme",
  "Vikend placevi",
  "Industrijski objekti",
  "Sanitarni objekti",
  "Pomoćni prostor",
];

export const PROCESS = [
  { title: "Pošaljete nam upit", text: "Kontakt putem forme ili telefona." },
  {
    title: "Dogovaramo namenu i osnovne zahteve",
    text: "Razgovaramo o vašoj nameni i osnovnim potrebama.",
  },
  { title: "Dobijate ponudu", text: "Pripremamo ponudu prema dogovoru." },
  { title: "Kreće izrada", text: "Po potvrdi započinje proizvodnja kontejnera." },
  {
    title: "Organizuje se isporuka",
    text: "Dogovaramo termin i način isporuke na vašu lokaciju.",
  },
];

// Full gallery items (with categories) for /galerija
export const GALLERY = [
  { src: IMG.standardni1, label: "Standardni kontejner", category: "standardni" },
  { src: IMG.standardni2, label: "Standardni kontejner", category: "standardni" },
  { src: IMG.standardni3, label: "Standardni kontejner", category: "standardni" },
  { src: IMG.stambeni1, label: "Stambeni kontejner", category: "stambeni" },
  { src: IMG.stambeni2, label: "Stambeni kontejner", category: "stambeni" },
  { src: IMG.stambeni3, label: "Stambeni kontejner", category: "stambeni" },
  { src: IMG.kancelarijski1, label: "Kancelarijski kontejner", category: "kancelarijski" },
  { src: IMG.kancelarijski2, label: "Kancelarijski kontejner", category: "kancelarijski" },
  { src: IMG.kancelarijski3, label: "Kancelarijski kontejner", category: "kancelarijski" },
  { src: IMG.sanitarni1, label: "Sanitarni kontejner", category: "sanitarni" },
  { src: IMG.sanitarni2, label: "Sanitarni kontejner", category: "sanitarni" },
  { src: IMG.sanitarni3, label: "Sanitarni kontejner", category: "sanitarni" },
  { src: IMG.gradjevinski1, label: "Građevinski kontejner", category: "gradjevinski" },
  { src: IMG.gradjevinski2, label: "Građevinski kontejner", category: "gradjevinski" },
  { src: IMG.gradjevinski3, label: "Građevinski kontejner", category: "gradjevinski" },
  { src: IMG.portirnice1, label: "Portirnica", category: "portirnice" },
  { src: IMG.portirnice2, label: "Portirnica", category: "portirnice" },
  { src: IMG.portirnice3, label: "Portirnica", category: "portirnice" },
  { src: IMG.pomocni1, label: "Vikendica", category: "pomocni" },
  { src: IMG.pomocni2, label: "Vikendica", category: "pomocni" },
  { src: IMG.pomocni3, label: "Vikendica", category: "pomocni" },
];

export const GALLERY_FILTERS = [
  { key: "all", label: "Svi" },
  { key: "standardni", label: "Standardni" },
  { key: "stambeni", label: "Stambeni" },
  { key: "kancelarijski", label: "Kancelarijski" },
  { key: "sanitarni", label: "Sanitarni" },
  { key: "portirnice", label: "Portirnice" },
  { key: "pomocni", label: "Vikendice" },
];

// Page meta (title + description) per route
export const PAGE_META = {
  "/": {
    title:
      "RB TIM | Standardni kontejneri, građevinski, stambeni i sanitarni kontejneri",
    description:
      "RB TIM izrađuje standardne kontejnere za stanovanje, kancelarije, gradilišta, sanitarne potrebe, portirnice i pomoćne objekte. Brza izrada i praktična rešenja.",
  },
  "/modeli-kontejnera": {
    title: "Modeli kontejnera | RB TIM",
    description:
      "Pregled svih modela kontejnera RB TIM: standardni, stambeni, kancelarijski, sanitarni, građevinski, portirnice i vikendice.",
  },
  "/standardni-kontejneri": {
    title: "Standardni kontejneri | RB TIM",
    description:
      "Standardni kontejneri RB TIM — praktično rešenje za različite namene, brza izrada i dostupnost.",
  },
  "/stambeni-kontejneri": {
    title: "Stambeni kontejneri | RB TIM",
    description:
      "Stambeni kontejneri za vikend objekte, privremeni smeštaj i dodatni stambeni prostor.",
  },
  "/kancelarijski-kontejneri": {
    title: "Kancelarijski kontejneri | RB TIM",
    description:
      "Kancelarijski kontejneri za firme, gradilišta i privremene poslovne potrebe.",
  },
  "/sanitarni-kontejneri": {
    title: "Sanitarni kontejneri | RB TIM",
    description:
      "Sanitarni kontejneri za toalete, tuševe i sanitarne potrebe na gradilištima i terenima.",
  },
  "/gradjevinski-kontejneri": {
    title: "Građevinski kontejneri | RB TIM",
    description:
      "Građevinski kontejneri za gradilišta, radnike, alat i opremu — praktična rešenja za teren.",
  },
  "/portirnice": {
    title: "Portirnice | RB TIM",
    description:
      "Portirnice za kontrolu ulaza, čuvarske pozicije, naplatne punktove i poslovne komplekse.",
  },
  "/pomocni-objekti": {
    title: "Vikendice | RB TIM",
    description:
      "Kontejnerske vikendice za plac, odmor, sezonski boravak i praktičan stambeni prostor po dogovoru.",
  },
  "/galerija": {
    title: "Galerija | RB TIM",
    description:
      "Primeri izvedenih kontejnera — galerija sa filtriranjem po kategorijama.",
  },
  "/o-nama": {
    title: "O nama | RB TIM",
    description:
      "RB TIM izrađuje standardne kontejnere za različite namene. Praktična rešenja i brza izrada.",
  },
  "/kontakt": {
    title: "Kontakt | RB TIM",
    description:
      "Pošaljite upit, recite nam za koju namenu vam je potreban kontejner i pripremićemo ponudu.",
  },
};
